// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { switchLanguage } from "../features/language/languageSlice";

// import tr from "../../src/icons-svg/icon_language-pink_tr.svg";
// import en from "../../src/icons-svg/icon_language-pink_en.svg";
// import fr from "../../src/icons-svg/icon_language-pink_fr.svg";
// import de from "../../src/icons-svg/icon_language-pink_de.svg";

// const FLAGS = [
//   { code: "fr-FR", label: "FR", src: fr },
//   { code: "en-EN", label: "EN", src: en },
//   { code: "de-DE", label: "DE", src: de },
//   { code: "tr-TR", label: "TR", src: tr },
// ];

// const normalizeLang = (v = "") =>
//   String(v).trim().toLowerCase().replace("_", "-");

// const LanguageSwitch = () => {
//   const dispatch = useDispatch();
//   const wrapRef = useRef(null);
//   const [open, setOpen] = useState(false);

//   const { language, languages } = useSelector((state) => state.language || {});
//   const activeLang = language || "tr-TR";

//   const menuItems = useMemo(() => {
//     if (Array.isArray(languages) && languages.length > 0) {
//       return [...languages]
//         .map((l) => {
//           const f =
//             FLAGS.find((x) => normalizeLang(x.code) === normalizeLang(l.code)) ||
//             FLAGS.find((x) =>
//               normalizeLang(x.code).startsWith(normalizeLang(l.code))
//             ) ||
//             null;

//           return {
//             code: l.code,
//             label: (l.name || l.code || "").toString(),
//             short:
//               (l.code || "").split("-")[0]?.toUpperCase() ||
//               (l.name || "").slice(0, 2).toUpperCase(),
//             src: f?.src,
//           };
//         })
//         .sort((a, b) => (a.label || "").localeCompare(b.label || ""));
//     }

//     return FLAGS.map((f) => ({
//       code: f.code,
//       label: f.label,
//       short: f.label,
//       src: f.src,
//     }));
//   }, [languages]);

//   const current = useMemo(() => {
//     const cur = normalizeLang(activeLang);

//     const exact = menuItems.find((x) => normalizeLang(x.code) === cur);
//     if (exact) return exact;

//     const base = cur.split("-")[0];
//     const byBase = menuItems.find((x) =>
//       normalizeLang(x.code).startsWith(base)
//     );
//     return byBase || menuItems[menuItems.length - 1];
//   }, [activeLang, menuItems]);

//   useEffect(() => {
//     const onDocClick = (e) => {
//       if (!wrapRef.current) return;
//       if (!wrapRef.current.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener("mousedown", onDocClick);
//     return () => document.removeEventListener("mousedown", onDocClick);
//   }, []);

//   const onSelect = (code) => {
//     dispatch(switchLanguage(code));
//     setOpen(false);
//   };

//   return (
//     <nav className="flex items-center w-full">
//       <div />
//       <div ref={wrapRef} className="relative ml-auto mr-2">
//         <button
//           type="button"
//           onClick={() => setOpen((v) => !v)}
//           className="
//             inline-flex items-center justify-center
//             p-1 rounded-md
//             bg-transparent
//             transition
//             focus:outline-none focus-visible:ring-2
//           "
//           aria-haspopup="menu"
//           aria-expanded={open}
//           title={current?.label}
//         >
//           {current?.src ? (
//             <img src={current.src} className="w-5 h-5" alt={current.label} />
//           ) : (
//             <span className="bg-gray-300 text-sm font-semibold px-1">
//               {current?.short || "TR"}
//             </span>
//           )}
//         </button>

//         {open && (
//           <div
//             className="
//               absolute right-0 mt-2
//               w-fit
//               rounded-lg overflow-hidden bg-gray-300
//                dark:bg-gray-300
//               border border-gray-200 dark:border-gray-700
//               shadow-lg z-50
//             "
//             role="menu"
//           >
//             {menuItems.map((item) => (
//               <button
//                 key={item.code}
//                 type="button"
//                 onClick={() => onSelect(item.code)}
//                 className="
//                   w-full
//                   px-3 py-2
//                   text-left whitespace-nowrap
//                   hover:bg-gray-100 dark:hover:bg-white/10
//                   text-gray-800 dark:text-white
//                 "
//                 role="menuitem"
//               >
//                 <span className="text-sm font-medium">
//                   {item.short || item.label}
//                 </span>
//               </button>
//             ))}
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default LanguageSwitch;
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { switchLanguage } from "../features/language/languageSlice";

import tr from "../../src/icons-svg/icon_language-pink_tr.svg";
import en from "../../src/icons-svg/icon_language-pink_en.svg";
import fr from "../../src/icons-svg/icon_language-pink_fr.svg";
import de from "../../src/icons-svg/icon_language-pink_de.svg";

const FLAGS = [
  { code: "fr", label: "FR", src: fr },
  { code: "en", label: "EN", src: en },
  { code: "de", label: "DE", src: de },
  { code: "tr", label: "TR", src: tr },
];

const normalizeLang = (v = "") => {
  const s = String(v || "").trim().toLowerCase().replace("_", "-");
  if (s.startsWith("tr")) return "tr";
  if (s.startsWith("en")) return "en";
  if (s.startsWith("fr")) return "fr";
  if (s.startsWith("de")) return "de";
  return "tr";
};

const LanguageSwitch = () => {
  const dispatch = useDispatch();
  const wrapRef = useRef(null);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });

  const { language, languages } = useSelector((state) => state.language || {});
  const activeLang = normalizeLang(language || "tr");

  const safeDefaultItems = useMemo(
    () =>
      FLAGS.map((f) => ({
        code: f.code,
        label: f.label,
        short: f.label,
        src: f.src,
      })),
    []
  );

  const menuItems = useMemo(() => {
    if (Array.isArray(languages) && languages.length > 0) {
      const mapped = languages
        .filter((l) => l && l.code)
        .map((l) => {
          const baseCode = normalizeLang(l.code);
          const flag = FLAGS.find((x) => x.code === baseCode) || null;

          return {
            code: baseCode,
            label: String(l.name || l.code || "").toUpperCase(),
            short: baseCode.toUpperCase(),
            src: flag?.src || null,
          };
        });

      if (mapped.length > 0) {
        const uniq = [];
        const seen = new Set();

        mapped.forEach((item) => {
          if (!seen.has(item.code)) {
            seen.add(item.code);
            uniq.push(item);
          }
        });

        return uniq.sort((a, b) => (a.label || "").localeCompare(b.label || ""));
      }
    }

    return safeDefaultItems;
  }, [languages, safeDefaultItems]);

  const current = useMemo(() => {
    return menuItems.find((x) => x.code === activeLang) || safeDefaultItems[0];
  }, [activeLang, menuItems, safeDefaultItems]);

  const updateMenuPosition = () => {
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();

    setMenuPos({
      top: rect.bottom + 4,
      left: rect.left,
    });
  };

  useLayoutEffect(() => {
    if (!open) return;
    updateMenuPosition();
  }, [open, menuItems.length]);

  useEffect(() => {
    if (!open) return;

    const handleOutside = (e) => {
      const target = e.target;
      if (wrapRef.current?.contains(target)) return;
      if (menuRef.current?.contains(target)) return;
      setOpen(false);
    };

    const handleReposition = () => updateMenuPosition();

    document.addEventListener("mousedown", handleOutside);
    window.addEventListener("resize", handleReposition);
    window.addEventListener("scroll", handleReposition, true);

    return () => {
      document.removeEventListener("mousedown", handleOutside);
      window.removeEventListener("resize", handleReposition);
      window.removeEventListener("scroll", handleReposition, true);
    };
  }, [open]);

  const onSelect = (code) => {
    const safeCode = normalizeLang(code);
    dispatch(switchLanguage(safeCode));
    setOpen(false);
  };

  const menu =
    open && typeof document !== "undefined"
      ? createPortal(
        <div
          ref={menuRef}
          role="menu"
          className="
fixed
flex flex-col
min-w-[42px]
rounded-md
overflow-hidden
bg-gray-300
border border-gray-200
shadow-lg
"
          style={{
            top: `${menuPos.top}px`,
            left: `${menuPos.left}px`,
            zIndex: 99999,
          }}
        >
          {menuItems.map((item) => (
            <button
              key={item.code}
              type="button"
              onClick={() => onSelect(item.code)}
              role="menuitem"
              className="
px-2 py-[4px]
text-left whitespace-nowrap
hover:bg-gray-100
text-gray-800
text-sm font-semibold
"
            >
              {item.short}
            </button>
          ))}
        </div>,
        document.body
      )
      : null;

  return (
    <>
      <nav className="flex items-center w-full relative z-[60]">
        <div />
        <div ref={wrapRef} className="relative ml-auto mr-2">
          <button
            ref={buttonRef}
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="
              inline-flex items-center justify-center
              p-1 rounded-md
              bg-transparent
              transition
              focus:outline-none focus-visible:ring-2
            "
            aria-haspopup="menu"
            aria-expanded={open}
            title={current?.label || "Language"}
          >
            {current?.src ? (
              <img
                src={current.src}
                className="w-5 h-5"
                alt={current.label || "Language"}
              />
            ) : (
              <span className="bg-gray-300 text-sm font-semibold px-1">
                {current?.short || "TR"}
              </span>
            )}
          </button>
        </div>
      </nav>

      {menu}
    </>
  );
};

export default LanguageSwitch;